// msalFactory.js
import { PublicClientApplication } from "@azure/msal-browser";

const instanceCache = new Map();   // clientId -> msal instance
const readyCache = new Map();      // clientId -> initialize() promise

export async function getMsal(clientId,tenantId) {
  const authority = `https://login.microsoftonline.com/${tenantId}`;
  if (!clientId) throw new Error("Missing MSAL clientId");

  // If we've already created & initialized this clientId, return it.
  if (instanceCache.has(clientId) && readyCache.has(clientId)) {
    await readyCache.get(clientId);
    return instanceCache.get(clientId);
  }

  // Build (or reuse) the instance
  let app = instanceCache.get(clientId);
  if (!app) {
    app = new PublicClientApplication({
      auth: { 
        clientId, 
        authority,
        redirectUri: window.location.origin +"/reports",   // must be registered as SPA redirect
        postLogoutRedirectUri: window.location.origin+"/reports"
    },
      cache: { cacheLocation: "localStorage", storeAuthStateInCookie: true },
      system: { allowRedirectInIframe: true }  // optional if you ever use redirect inside iframes
    });
    instanceCache.set(clientId, app);
  }

  // Initialize once per clientId
  if (!readyCache.has(clientId)) {
    const initPromise = app.initialize();
    readyCache.set(clientId, initPromise);
  }

  await readyCache.get(clientId);
  return app;
}
